import firebaseConfig from "utils/firebaseConfig";

// The push service worker, at the script and scope Firebase uses by default, so Firebase reuses this registration.
const PUSH_WORKER = "/firebase-messaging-sw.js";
const PUSH_SCOPE = "/firebase-cloud-messaging-push-scope";
// How long to wait for a new push worker to start before asking for the token anyway.
const PUSH_WORKER_WAIT_MS = 10 * 1000;

// Starts the push worker when the app loads. Firebase 9 asks for the device token as soon as it has registered the
// worker, and on a browser's first visit the worker wasn't running yet at sign-in, so the token request failed
// ("no active Service Worker") and the coach was only registered on the next page load. Started here, it is
// running by the time the coach has signed in and allowed notifications.
export const startPushWorker = () => {
  if (!firebaseConfig || !("serviceWorker" in navigator)) return;
  navigator.serviceWorker
    .register(PUSH_WORKER, { scope: PUSH_SCOPE })
    .catch((error) => console.warn("The push worker could not be started", error));
};

// Resolves once the push worker is running. The install card asks for the token right after the coach allowed
// notifications, which can come before the worker started at load has finished installing.
export const pushWorkerReady = () =>
  navigator.serviceWorker.register(PUSH_WORKER, { scope: PUSH_SCOPE }).then((registration) => {
    const worker = registration.installing || registration.waiting;
    if (registration.active || !worker || worker.state === "activated") return registration;
    return new Promise((resolve) => {
      const timer = setTimeout(() => resolve(registration), PUSH_WORKER_WAIT_MS);
      worker.addEventListener("statechange", () => {
        // A worker that failed to install won't start either; Firebase reports that as before.
        if (worker.state !== "activated" && worker.state !== "redundant") return;
        clearTimeout(timer);
        resolve(registration);
      });
    });
  });
